import { connectHook } from 'app/common/components/connect-hook';
import Topbar from './topbar.js';
import { useTopbar } from './topbar-hook.js';

export default connectHook(Topbar, useTopbar);
